import { render, staticRenderFns } from "./BidderDataViewTemplate.vue?vue&type=template&id=3fd09f49&scoped=true&"
import script from "./BidderDataViewTemplate.vue?vue&type=script&lang=js&"
export * from "./BidderDataViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd09f49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VSpacer,VTab,VTabs})
